import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalBotModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    timeoutRespostaSolicitanteMin = 5,
    timeoutRespostaSolicitanteMensagem = '',
    timeoutEncerramentoAtendimentoMin = 8,
    timeoutEncerramentoAtendimentoMensagem = '',
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.Bot)
    this.timeoutRespostaSolicitanteMin = timeoutRespostaSolicitanteMin
    this.timeoutRespostaSolicitanteMensagem = timeoutRespostaSolicitanteMensagem
    this.timeoutEncerramentoAtendimentoMin = timeoutEncerramentoAtendimentoMin
    this.timeoutEncerramentoAtendimentoMensagem = timeoutEncerramentoAtendimentoMensagem
  }
}
